import "./FoodGrid.css";

import FoodCard from "../FoodCard/FoodCard";
import EmptyFoods from "../EmptyFoods/EmptyFoods";

function FoodGrid({
  foods = [],

  onView,
  onEdit,
  onDelete,
  onToggleAvailability,

  onAddFood,
}) {
  if (foods.length === 0) {
    return (
      <EmptyFoods
        onAddFood={onAddFood}
      />
    );
  }

  return (
    <div className="food-grid">

      {foods.map((food) => (
        <FoodCard
          key={food._id}
          food={food}
          onView={onView}
          onEdit={onEdit}
          onDelete={onDelete}
          onToggleAvailability={onToggleAvailability}
        />
      ))}

    </div>
  );
}

export default FoodGrid;